import { render, staticRenderFns } from "./EmActionButton.vue?vue&type=template&id=54257d66&"
import script from "./EmActionButton.vue?vue&type=script&lang=js&"
export * from "./EmActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports